import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_418acca9: FaireBrandEntity = {
  token: "b_418acca9",
  type: "brand",
  name: "Streamline",
  avatarUrl:
    "https://cdn.faire.com/fastly/75cd626dcbaa9ca78849364274a9d3495f0043cd9719f78d40fd10504e8bb849.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2c75649a3b75644c84eafdcf7c7b6f8c2a76936d2fff15099882bcf4a0d04f4a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/75cd626dcbaa9ca78849364274a9d3495f0043cd9719f78d40fd10504e8bb849.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2c75649a3b75644c84eafdcf7c7b6f8c2a76936d2fff15099882bcf4a0d04f4a.jpeg",
  location: "Congers, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 1048,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 1987, Streamline is a fun yet functional brand. Specializing in everything from whimsical home decor to play time toys, this line is sure to bring a smile to your face. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:18.715Z",
    importedBy: "entity-db-cli",
  },
};
